/* eslint react/prop-types: 0 */
import React from 'react';
import { Col, Row } from 'reactstrap';
import { adjustStringLength } from '@utils/navigationHelpers';
import { displayNameLimits } from '@data/navigation';
import FooterNavigationList from './FooterNavigationList';

const FooterNavigation = ({ items }) => {
  const footerNavigationItems = items.filter((item) => item.type === 'Multiple');
  return (
    <Row>
      { footerNavigationItems.map((item) => (
        <Col lg={4} md={4} key={`${item.title}`}>
          <p className="footer-heading">{adjustStringLength(item.title, displayNameLimits.footerSectionTitle)}</p>
          <FooterNavigationList
            links={item.links}
            listClassName="list-unstyled"
          />
        </Col>
      )) }
    </Row>
  );
};

export default FooterNavigation;
